import { NexCollectionKey } from 'config/constants/nftsCollections/types'
import nexCollections from 'config/constants/nftsCollections'
import { getAddress } from 'utils/addressHelpers'

export const nftsBaseUrl = '/nfts'
export const glitchAddress = getAddress(nexCollections[NexCollectionKey.GLITCH].address)
// export const nexSquadAddress = getAddress(nexCollections[NexCollectionKey.SQUAD].address)
